var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ui-date" }, [
    _c("input", {
      staticClass: "i-box",
      attrs: { type: "text", placeholder: "YYYY / MM" },
      domProps: { value: _vm.text },
      on: { keyup: _vm.input, compositionend: _vm.input }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }